import { render, staticRenderFns } from "./MessageCenterHelp.vue?vue&type=template&id=c58951b2"
import script from "./MessageCenterHelp.vue?vue&type=script&lang=js"
export * from "./MessageCenterHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports